let images = {
    "GORODNICHY": 1,
    "ANNA-ANDREEVNA": 2,
    "MARJA-ANTONOVNA": 3,
    "LUKA-LUKICH": 4,
    "Zhena-LUKI-LUKICHA": 5,
    "AMMOS-FEDOROVICH": 6,
    "ARTEMIY-FILIPPOVICH": 7,
    "POCHTMEISTER": 8,
    "DOBCHINSKY": 9,
    "BOBCHINSKY": 10,
    "HLESTAKOV": 11,
    "OSIP": 12,
    "LULUKOV": 13,
    "RASTAKOVSKY": 14,
    "KOROBKIN": 15,
    "Zhena-KOROBKINA": 16,
    "CHASTNY-PRISTAV": 17,
    "SVISTUNOV": 18,
    "DERZHIMORDA": 19,
    "Slesarsha": 20,
    "UNTEROFICERSHA": 21,
    "GOLOSA-DVUH-ZHENSCHIN": 22,
    "MISHKA": 23,
    "SLUGA": 24,
    "KUPCY": 25,
    "Golos-YAMSCHIKA": 26,
    "ZHANDARM": 27,
    "GOSTJA": 28,
    "GIBNER-LEKAR": 29,
    "ALL": 30,
}

export default images;
